import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth-guard';
import { HubspotEntryComponent } from './auth/containers/hubspot-entry-component';
import { OAuthCallbackComponent } from './auth/containers/oauth-callback-component';
import { NotAuthenticatedComponent } from './auth/containers/not-authenticated-component';

export const routes: Routes = [
  { path: '', redirectTo: 'offers', pathMatch: 'full' },
  { path: 'not-authenticated', component: NotAuthenticatedComponent },
  { path: 'auth/hubspot', component: HubspotEntryComponent },
  { path: 'oauth/callback', component: OAuthCallbackComponent },
  {
    path: 'offers',
    canActivate: [authGuard],
    loadChildren: () => import('./offers/offers.routes').then((m) => m.routes),
  },
  {
    path: 'debug-sentry',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./debug-sentry/debug-sentry.routes').then((m) => m.routes),
  },
];
